module.exports = __webpack_public_path__ + "static/media/freda_sisulu.36b7d379.png";